import React, { useEffect, useState, useRef, useMemo } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputSwitch } from "primereact/inputswitch";

import "./style.css";
import "primeicons/primeicons.css";

// Importando os diálogos da mesma pasta que o Agendas usa
import DialogSucesso from "../Agendas/DialogSucesso";
import DialogErro from "../Agendas/DialogErro";
import DialogConfirmarCaixa from "./DialogConfirmarCaixa";
import DialogEditarCaixa from "./DialogEditarCaixa";
import DialogDetalhes from "./DialogDetalhes";
import FecharCaixa from "./FecharCaixa";

import {
  FaCashRegister,
  FaCalendarAlt,
  FaClock,
  FaBuilding,
  FaUserMd,
  FaUserCircle,
  FaIdCard,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

const Caixa = () => {
  // ===== ESTADOS DO SISTEMA =====
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [caixas, setCaixas] = useState([]);

  // ===== ESTADOS PARA CONTROLE DE VISUALIZAÇÃO =====
  const [visualizacaoResumida, setVisualizacaoResumida] = useState(true);
  const [checked, setChecked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // ===== ESTADOS PARA DIALOGS =====
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showConfirmCaixa, setShowConfirmCaixa] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  // ===== ESTADOS PARA EDIÇÃO =====
  const [editarCaixa, setEditarCaixa] = useState(false);
  const [reservaEditando, setReservaEditando] = useState(null);

  // ===== ESTADOS DO PAGAMENTO SELECIONADO =====
  const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
  const [showFecharCaixa, setShowFecharCaixa] = useState(false);

  // ===== ESTADOS PARA FILTROS E CALENDÁRIO =====
  const [mostrarCalendario, setMostrarCalendario] = useState(false);
  const [dialogInformacoes, setDialogInformacoes] = useState(false);
  const [diaSelecionado, setDiaSelecionado] = useState(new Date());
  const [mesCalendario, setMesCalendario] = useState(new Date());
  const [mostrarFiltroAgenda, setMostrarFiltroAgenda] = useState(false);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCpf, setFiltroCpf] = useState("");
  const [filtroTelefone, setFiltroTelefone] = useState("");
  const [filtroEmail, setFiltroEmail] = useState("");

  // ===== REF =====
  const caixaIdRef = useRef(null);

  // ===== DETECÇÃO DE DISPOSITIVO MÓVEL =====
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // ===== EFECTS =====
  useEffect(() => {
    fetchCaixas(checked);
  }, []);

  // ===== FUNÇÕES DE API =====
  const fetchCaixas = async (showAll = false) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const url =
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/caixas";

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Erro ao buscar caixas");
      }

      const result = await response.json();

      console.log("Caixas = ", result.data)

      if (result.success && Array.isArray(result.data)) {
        let filteredData = result.data;

        if (!showAll) {
          // Modo normal: mostrar apenas "aberto" E "pendente"
          filteredData = result.data.filter(
            (caixa) =>
              caixa.status_pagamento === "pago_parcial" ||
              caixa.status === "aberto",
          );
        } else {
          // Modo "todos": mostrar todos os status
          filteredData = result.data;
        }
        setCaixas(filteredData);
        setError(null);
      } else {
        setCaixas([]);
        setError("Nenhum caixa encontrado.");
      }
    } catch (error) {
      setError(error.message);
      setCaixas([]);
    } finally {
      setLoading(false);
    }
  };

  // ===== FUNÇÕES DE UTILIDADE =====
  const formatarData = (dataStr) => {
    if (!dataStr) return "-";

    try {
      if (dataStr.includes(" ")) {
        dataStr = dataStr.split(" ")[0];
      } else if (dataStr.includes("T")) {
        dataStr = dataStr.split("T")[0];
      }

      const [ano, mes, dia] = dataStr.split("-").map(Number);
      const data = new Date(ano, mes - 1, dia);

      return data.toLocaleDateString("pt-BR");
    } catch (e) {
      console.error("Erro ao formatar data:", e);
      return dataStr;
    }
  };

  const formatarHorario = (horario) => horario;

  const showSuccessMessage = (message) => {
    setDialogMessage(message);
    setShowSuccessDialog(true);
  };

  const showErrorMessage = (message) => {
    setDialogMessage(message);
    setShowErrorDialog(true);
  };

  const handleSwitchChange = (e) => {
    const newValue = e.value;
    setChecked(newValue);
    fetchCaixas(newValue);
  };

  // ===== FUNÇÕES DO CALENDÁRIO =====
  const verificarReservasNoDia = (data) => {
    if (!caixas || caixas.length === 0) return false;

    const dataFormatada = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;

    return caixas.some(
      (caixa) => caixa.data_cadastro?.split(" ")[0] === dataFormatada,
    );
  };

  const gerarDiasCalendario = () => {
    const ano = mesCalendario.getFullYear();
    const mes = mesCalendario.getMonth();

    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);
    const diaSemanaInicio = primeiroDia.getDay();

    const dias = [];

    for (let i = diaSemanaInicio - 1; i >= 0; i--) {
      const data = new Date(ano, mes, -i);
      dias.push({
        data,
        disponivel: true,
        selecionado: false,
        possuiReserva: verificarReservasNoDia(data),
        outroMes: true,
      });
    }

    for (let dia = 1; dia <= ultimoDia.getDate(); dia++) {
      const data = new Date(ano, mes, dia);

      const dataFormatada = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
      const diaSelecionadoFormatado = `${diaSelecionado.getFullYear()}-${String(diaSelecionado.getMonth() + 1).padStart(2, "0")}-${String(diaSelecionado.getDate()).padStart(2, "0")}`;

      const selecionado = diaSelecionadoFormatado === dataFormatada;
      const possuiReserva = verificarReservasNoDia(data);

      dias.push({
        data,
        disponivel: true,
        selecionado,
        possuiReserva,
        outroMes: false,
      });
    }

    const totalCells = 42;
    while (dias.length < totalCells) {
      const data = new Date(
        ano,
        mes + 1,
        dias.length - ultimoDia.getDate() - diaSemanaInicio + 1,
      );
      dias.push({
        data,
        disponivel: true,
        selecionado: false,
        possuiReserva: verificarReservasNoDia(data),
        outroMes: true,
      });
    }

    return dias;
  };

  const handleSelecionarDia = (dia) => {
    if (!dia.disponivel) return;
    setDiaSelecionado(new Date(dia.data));
  };

  const handleMudarMes = (direcao) => {
    const novoMes = new Date(mesCalendario);
    if (direcao === "proximo") {
      novoMes.setMonth(novoMes.getMonth() + 1);
    } else {
      novoMes.setMonth(novoMes.getMonth() - 1);
    }
    setMesCalendario(novoMes);
  };

  const irParaDiaAnterior = () => {
    const novoDia = new Date(diaSelecionado);
    novoDia.setDate(novoDia.getDate() - 1);
    setDiaSelecionado(novoDia);
  };

  const irParaProximoDia = () => {
    const novoDia = new Date(diaSelecionado);
    novoDia.setDate(novoDia.getDate() + 1);
    setDiaSelecionado(novoDia);
  };

  const irParaHoje = () => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    setDiaSelecionado(hoje);
  };

  // ===== FUNÇÃO PARA IMPRIMIR RECIBO =====
  const handleImprimirRecibo = (dadosRecibo) => {
    const nomePaciente = dadosRecibo?.paciente_nome ?? "Paciente";
    const cpfPaciente = dadosRecibo?.paciente_cpf ?? "-";
    const docNumero = dadosRecibo?.agendamento_id ?? "-";

    const nomeDentista = dadosRecibo?.profissional_nome ?? "-";
    const especDentista = dadosRecibo?.profissional_especialidade ?? "-";

    const acrescimo = parseFloat(dadosRecibo?.valor_acrescimo || 0);
    const desconto = parseFloat(dadosRecibo?.valor_desconto || 0);

    const pagamentos = dadosRecibo?.pagamentos || [];
    const totalPagoNum = pagamentos.reduce((acc, p) => {
      const valor = parseFloat(p.valor) || 0;
      return acc + valor;
    }, 0);
    const totalPago = totalPagoNum.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
    });

    const pagamentosHtml = pagamentos.length
      ? pagamentos
          .map((p) => {
            const desc = p.forma_pagamento_descricao ?? p.descricao ?? "-";
            const valor = parseFloat(p.valor) || 0;
            return `
        <div class="row">
          <span>${desc}</span>
          <span>R$ ${valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</span>
        </div>
      `;
          })
          .join("")
      : `<div class="small muted">Nenhum pagamento registrado</div>`;

    const descontoHtml =
      desconto > 0
        ? `
    <div class="row">
      <span><i>Desconto</i></span>
      <span>- R$ ${desconto.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</span>
    </div>
  `
        : "";

    const acrescimoHtml =
      acrescimo > 0
        ? `
    <div class="row">
      <span><i>Acréscimo</i></span>
      <span>+ R$ ${acrescimo.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</span>
    </div>
  `
        : "";

    const html = `
<!doctype html>
<html lang="pt-BR">
<head>
<meta charset="utf-8"/>
<title>Recibo</title>

<style>
  body{font-family: monospace; display:flex; justify-content:center; background:#fff;}
  .recibo{width:320px; font-size:12px; line-height:1.35; color:#000;}
  .center{text-align:center}
  .bold{font-weight:700}
  .muted{color:#444}
  .line{border-top:1px dashed #000; margin:8px 0}
  .row{display:flex; justify-content:space-between; gap:10px; margin:2px 0; align-items: flex-start;}
  .row .descricao{flex:1; text-align:left; word-break:break-word;}
  .row .valor{white-space:nowrap; margin-left:10px;}
  .title{font-size:14px; font-weight:bold; text-align:center; margin-bottom:6px}
  .total{font-size:14px; font-weight:bold; margin-top:6px}
  .small{font-size:11px}
  .assinatura{margin-top:38px; text-align:center}
  @media print{ body{margin:0} }
</style>
</head>

<body>
<div class="recibo">

  <div class="title">RECIBO</div>
  <div class="center small">
    ${dadosRecibo?.empresa_nome ?? "-"}<br/>
    ${dadosRecibo?.empresa_cidade ?? "-"} - ${dadosRecibo?.empresa_estado ?? "-"}
  </div>

  <div class="line"></div>

  <div class="row">
    <span><b>Data:</b> ${new Date().toLocaleDateString("pt-BR")}</span>
    <span><b>Nº:</b> ${docNumero}</span>
  </div>

  <div class="line"></div>

  <div><b>Paciente:</b> ${nomePaciente}</div>
  <div><b>CPF:</b> ${cpfPaciente}</div>

  <div class="line"></div>

  <div><b>Profissional:</b> ${nomeDentista}</div>
  <div><b>Especialidade:</b> ${especDentista}</div>

  <div class="line"></div>

  <div class="bold">PROCEDIMENTOS</div>

  ${(dadosRecibo?.itens ?? [])
    .map(
      (it) => `
        <div class="row">
          <span class="descricao">${it.descricao ?? "-"}</span>
          <span class="valor">R$ ${Number(it.valor || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</span>
        </div>
      `,
    )
    .join("")}

  ${acrescimoHtml}
  ${descontoHtml}

  <div class="line"></div>

  <div class="bold">FORMA(S) DE PAGAMENTO</div>
  ${pagamentosHtml}

  <div class="line"></div>

  <div class="row total">
    <span>TOTAL PAGO</span>
    <span>R$ ${totalPago}</span>
  </div>

  <div class="line"></div>

  <div class="small" style="text-align:justify">
    Declaramos que o(a) paciente <b>${nomePaciente}</b> realizou os procedimentos descritos,
    estando quitado o valor total de <b>R$ ${totalPago}</b> referente aos serviços prestados.
  </div>

  <div class="assinatura">
    ____________________________________<br/>
    ${nomeDentista}<br/>
    ${especDentista}
  </div>

</div>

<script>window.onload = () => window.print();</script>
</body>
</html>
`;

    const w = window.open(
      "",
      "_blank",
      "width=1000,height=800,left=100,top=50,scrollbars=yes",
    );
    if (!w) {
      alert("Por favor, permita pop-ups para imprimir o recibo.");
      return;
    }

    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  // ===== AGENDAMENTOS FILTRADOS =====
  const caixasFiltrados = useMemo(() => {
    return caixas.filter((caixa) => {
      const dataAgendamento = caixa.data_cadastro?.split(" ")[0];
      const dataSelecionada = `${diaSelecionado.getFullYear()}-${String(
        diaSelecionado.getMonth() + 1,
      ).padStart(2, "0")}-${String(diaSelecionado.getDate()).padStart(2, "0")}`;
      const dataMatch = dataAgendamento === dataSelecionada;

      const nomeMatch =
        !filtroNome ||
        caixa.paciente_nome?.toLowerCase().includes(filtroNome.toLowerCase());
      const cpfMatch =
        !filtroCpf ||
        caixa.paciente_cpf?.toLowerCase().includes(filtroCpf.toLowerCase());
      const telefoneMatch =
        !filtroTelefone ||
        caixa.paciente_telefone
          ?.toLowerCase()
          .includes(filtroTelefone.toLowerCase());
      const emailMatch =
        !filtroEmail ||
        caixa.paciente_email?.toLowerCase().includes(filtroEmail.toLowerCase());

      return dataMatch && nomeMatch && cpfMatch && telefoneMatch && emailMatch;
    });
  }, [
    caixas,
    diaSelecionado,
    filtroNome,
    filtroCpf,
    filtroTelefone,
    filtroEmail,
  ]);

  // ===== RENDER PRINCIPAL =====
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* ===== DIÁLOGOS REUTILIZÁVEIS ===== */}
      <DialogSucesso
        visible={showSuccessDialog}
        onHide={() => {
          setShowSuccessDialog(false);
          if (caixaIdRef.current) {
            setShowConfirmCaixa(true);
          }
        }}
        message={dialogMessage}
        onConfirm={() => {
          setShowSuccessDialog(false);
          if (caixaIdRef.current) {
            setShowConfirmCaixa(true);
          }
        }}
      />

      <DialogErro
        visible={showErrorDialog}
        onHide={() => setShowErrorDialog(false)}
        message={dialogMessage}
      />

      <DialogConfirmarCaixa
        visible={showConfirmCaixa}
        onHide={() => {
          setShowConfirmCaixa(false);
          caixaIdRef.current = null;
        }}
        onConfirm={() => {
          setShowConfirmCaixa(false);
          caixaIdRef.current = null;
          setPagamentoSelecionado(null);
          setShowFecharCaixa(false);
        }}
      />

      {/* ===== DIALOG DE EDIÇÃO ===== */}
      <DialogEditarCaixa
        visible={editarCaixa}
        onHide={() => setEditarCaixa(false)}
        reservaEditando={reservaEditando}
        fetchCaixas={fetchCaixas}
        showSuccessMessage={showSuccessMessage}
        showErrorMessage={showErrorMessage}
        checked={checked}
      />

      {/* ===== DIALOG DE INFORMAÇÕES ===== */}
      <DialogDetalhes
        visible={dialogInformacoes}
        onHide={() => setDialogInformacoes(false)}
        dados={reservaEditando}
        formatarData={formatarData}
        formatarHorario={formatarHorario}
      />

      {/* ===== COMPONENTE FECHAR CAIXA ===== */}
      <FecharCaixa
        visible={showFecharCaixa}
        onHide={() => {
          setShowFecharCaixa(false);
          setPagamentoSelecionado(null);
        }}
        pagamentoSelecionado={pagamentoSelecionado}
        onSuccess={(message, reciboData) => {
          showSuccessMessage(message);
          if (reciboData) {
            window.pendenteImpressao = reciboData;
          }
        }}
        onError={showErrorMessage}
        onFechado={() => {
          fetchCaixas(checked);
          setShowFecharCaixa(false);
          setPagamentoSelecionado(null);
        }}
      />

      {/* ===== BARRA SUPERIOR ===== */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div></div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => {
              fetchCaixas();
              setChecked(false);
              irParaHoje();
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={visualizacaoResumida ? "pi pi-eye" : "pi pi-eye-slash"}
            className="icon-button-titulo"
            onClick={() => setVisualizacaoResumida(!visualizacaoResumida)}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={mostrarFiltroAgenda ? "pi pi-filter-slash" : "pi pi-filter"}
            className="icon-button-titulo"
            onClick={() => setMostrarFiltroAgenda(!mostrarFiltroAgenda)}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={
              mostrarCalendario ? "pi pi-calendar-minus" : "pi pi-calendar-plus"
            }
            className="icon-button-titulo"
            onClick={() => setMostrarCalendario(!mostrarCalendario)}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
        </div>
        <div></div>
      </div>

      {/* ===== CONTEÚDO PRINCIPAL ===== */}
      <div style={{ flex: 1, padding: "50px 10px" }}>
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          {/* Cabeçalho */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <FaCashRegister
                style={{ color: "#B83732", fontSize: "1.2rem" }}
              />
              <h3 style={{ margin: 0, color: "#424242" }}>CAIXAS</h3>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "25px",
                  height: "25px",
                  background:
                    "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                  borderRadius: "50px",
                  padding: "0 8px",
                  margin: "0 8px",
                  boxShadow: "0 2px 4px rgba(184, 55, 50, 0.2)",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "0.85rem",
                    fontWeight: "600",
                    lineHeight: 1,
                  }}
                >
                  {caixasFiltrados.length}
                </span>
              </div>
            </div>
            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <Button
                icon="pi pi-chevron-left"
                className="p-button-text p-button-sm"
                onClick={irParaDiaAnterior}
                tooltip="Dia anterior"
                style={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  color: "#424242",
                }}
              />
              <h3 style={{ margin: 0, color: "#424242" }}>
                {diaSelecionado.toLocaleDateString("pt-BR")}
              </h3>
              <Button
                icon="pi pi-chevron-right"
                className="p-button-text p-button-sm"
                onClick={irParaProximoDia}
                tooltip="Próximo Dia"
                style={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  color: "#424242",
                }}
              />
            </div>
          </div>

          {/* Switch Mostrar Todos */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "12px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <InputSwitch
                checked={checked}
                onChange={handleSwitchChange}
                style={{ transform: "scale(0.8)" }}
              />
              <span style={{ fontSize: "0.85rem", color: "#4A5568" }}>
                Mostrar fechados
              </span>
            </div>
          </div>

          {/* CALENDÁRIO */}
          {mostrarCalendario && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "920px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "5px",
                  }}
                >
                  <Button
                    icon="pi pi-chevron-left"
                    className="p-button-text p-button-sm"
                    onClick={() => handleMudarMes("anterior")}
                    style={{
                      border: "none",
                      outline: "none",
                      boxShadow: "none",
                      color: "#424242",
                      width: "30px",
                      height: "30px",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "1rem",
                      fontWeight: "bold",
                      color: "#424242",
                      margin: "0 10px",
                    }}
                  >
                    {mesCalendario
                      .toLocaleDateString("pt-BR", {
                        month: "long",
                        year: "numeric",
                      })
                      .toUpperCase()}
                  </span>
                  <Button
                    icon="pi pi-chevron-right"
                    className="p-button-text p-button-sm"
                    onClick={() => handleMudarMes("proximo")}
                    style={{
                      border: "none",
                      outline: "none",
                      boxShadow: "none",
                      color: "#424242",
                      width: "30px",
                      height: "30px",
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(7, 1fr)",
                    gap: "2px",
                    marginBottom: "10px",
                  }}
                >
                  {["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"].map(
                    (dia) => (
                      <div
                        key={dia}
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          padding: "5px 2px",
                          backgroundColor: "#e9ecef",
                          borderRadius: "3px",
                          fontSize: "0.8rem",
                          color: "#495057",
                        }}
                      >
                        {dia}
                      </div>
                    ),
                  )}

                  {gerarDiasCalendario().map((dia, index) => {
                    const clicavel =
                      dia.disponivel !== false ||
                      (dia.possuiReserva && dia.disponivel !== false);

                    let backgroundColor = "#ffffff";
                    if (dia.selecionado) backgroundColor = "#fff0f0";
                    else if (dia.outroMes) backgroundColor = "#f8f9fa";
                    else if (dia.possuiReserva) backgroundColor = "#e8f5e9";

                    let color = "#424242";
                    if (dia.outroMes) color = "#adb5bd";
                    else if (dia.selecionado) color = "#b83732";
                    else if (dia.possuiReserva) color = "#28a745";

                    let borderColor = "#dee2e6";
                    if (dia.selecionado) borderColor = "#a8322d";
                    else if (dia.possuiReserva) borderColor = "#28a745";

                    return (
                      <div
                        key={index}
                        onClick={() => clicavel && handleSelecionarDia(dia)}
                        style={{
                          textAlign: "center",
                          padding: "8px 1px",
                          backgroundColor,
                          borderRadius: "4px",
                          cursor: clicavel ? "pointer" : "not-allowed",
                          border: `1px solid ${borderColor}`,
                          fontWeight: dia.selecionado ? "bold" : "normal",
                          color,
                          position: "relative",
                          height: "45px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "0.85rem",
                          opacity: dia.outroMes ? 0.6 : 1,
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            fontWeight:
                              dia.data.getDate() === new Date().getDate() &&
                              !dia.outroMes
                                ? "bold"
                                : "normal",
                            fontSize: "0.85rem",
                          }}
                        >
                          {dia.data.getDate()}
                        </div>

                        {dia.possuiReserva && !dia.outroMes && (
                          <div
                            style={{
                              position: "absolute",
                              top: "3px",
                              right: "3px",
                              width: "8px",
                              height: "8px",
                              backgroundColor: "#28a745",
                              borderRadius: "50%",
                            }}
                          />
                        )}

                        {dia.data.getDate() === new Date().getDate() &&
                          dia.data.getMonth() === new Date().getMonth() &&
                          dia.data.getFullYear() === new Date().getFullYear() &&
                          !dia.outroMes && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "2px",
                                width: "4px",
                                height: "4px",
                                backgroundColor: "#007bff",
                                borderRadius: "50%",
                              }}
                            />
                          )}
                      </div>
                    );
                  })}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                    flexWrap: "wrap",
                    fontSize: "0.75rem",
                    paddingTop: "10px",
                    borderTop: "1px solid #e0e0e0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#b83732",
                        borderRadius: "2px",
                      }}
                    />
                    <span style={{ color: "#6c757d" }}>Selecionado</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#28a745",
                        borderRadius: "2px",
                      }}
                    />
                    <span style={{ color: "#6c757d" }}>Com caixa</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #007bff",
                        borderRadius: "2px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          bottom: "1px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "4px",
                          height: "4px",
                          backgroundColor: "#007bff",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                    <span style={{ color: "#6c757d" }}>Hoje</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* FILTROS */}
          {mostrarFiltroAgenda && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "920px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaUserMd
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                          }}
                        >
                          Nome
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Nome do paciente"
                        value={filtroNome}
                        onChange={(e) => setFiltroNome(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #E67E22",
                        }}
                      >
                        <FaIdCard
                          style={{ color: "#E67E22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                          }}
                        >
                          CPF
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="CPF do paciente"
                        value={filtroCpf}
                        onChange={(e) => setFiltroCpf(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #2980b9",
                        }}
                      >
                        <FaPhone
                          style={{ color: "#2980b9", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                          }}
                        >
                          Telefone
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Telefone do paciente"
                        value={filtroTelefone}
                        onChange={(e) => setFiltroTelefone(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #d35400",
                        }}
                      >
                        <FaEnvelope
                          style={{ color: "#d35400", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                          }}
                        >
                          Email
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Email do paciente"
                        value={filtroEmail}
                        onChange={(e) => setFiltroEmail(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* LISTA DE CAIXAS */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {caixasFiltrados.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaCashRegister
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhum caixa encontrado
                </h3>
              </div>
            ) : !visualizacaoResumida ? (
              /* VISUALIZAÇÃO EM LINHA */
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {caixasFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px 14px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          minWidth: isMobile ? "180px" : "260px",
                          flex: "1 1 260px",
                        }}
                      >
                        <FaUserCircle
                          style={{
                            fontSize: isMobile ? "1.8rem" : "2.5rem",
                            color: "#D65A55",
                            flexShrink: 0,
                          }}
                        />
                        <div style={{ minWidth: 0 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.paciente_nome}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "5px",
                              alignItems: "center",
                              color: "#64748b",
                              fontSize: "0.9rem",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                marginRight: "6px",
                              }}
                            >
                              <i
                                className="pi pi-phone"
                                style={{ fontSize: "0.7rem" }}
                              />
                              <span>{item.paciente_telefone}</span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                color: "#64748b",
                                fontSize: "0.85rem",
                              }}
                            >
                              <i
                                className="pi pi-tag"
                                style={{ fontSize: "0.7rem" }}
                              />
                              <span>{item.agendamento_id}</span>
                            </div>
                            {/* Só mostrar data, hora e empresa se NÃO for mobile */}
                            {!isMobile && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    marginRight: "6px",
                                  }}
                                >
                                  <FaCalendarAlt
                                    style={{ fontSize: "0.7rem", color: "#2ecc71" }}
                                  />
                                  <span>{formatarData(item.data_atendimento)}</span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    marginRight: "6px",
                                  }}
                                >
                                  <FaClock
                                    style={{ fontSize: "0.7rem", color: "#f39c12" }}
                                  />
                                  <span>{formatarHorario(item.horario)}</span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <FaBuilding
                                    style={{ fontSize: "0.7rem", color: "#3498db" }}
                                  />
                                  <span>{item.empresa_nome}</span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: "8px",
                          flex: "1 1 320px",
                          marginLeft: "auto",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            flexWrap: "wrap",
                          }}
                        >
                          {item.status === "fechado" ? (
                            <span
                              style={{
                                backgroundColor: "#d4edda",
                                color: "#155724",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "0.75rem",
                                fontWeight: "600",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <i
                                className="pi pi-check"
                                style={{ fontSize: "0.7rem" }}
                              />
                              FECHADO
                            </span>
                          ) : (
                            <span
                              style={{
                                backgroundColor: "#fff3cd",
                                color: "#856404",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "0.75rem",
                                fontWeight: "600",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <i
                                className="pi pi-clock"
                                style={{ fontSize: "0.7rem" }}
                              />
                              ABERTO
                            </span>
                          )}
                        </div>

                        {(item.status === "aberto" ||
                          item.status === "pendente") && (
                          <div style={{ display: "flex", gap: "5px" }}>
                            <Button
                              icon="pi pi-check"
                              onClick={() => {
                                if (
                                  user.tipo === "administrator" ||
                                  user.modulos?.Caixa?.editar
                                ) {
                                  setPagamentoSelecionado(item);
                                  setShowFecharCaixa(true);
                                }
                              }}
                              disabled={
                                !(
                                  user.tipo === "administrator" ||
                                  user.modulos?.Caixa?.editar
                                )
                              }
                              className="p-button-success p-button-sm"
                              style={{
                                outline: "none",
                                boxShadow: "none",
                                width: "25px",
                                height: "25px",
                                borderColor: "#dee2e6",
                              }}
                              tooltip="Finalizar caixa"
                              tooltipOptions={{ position: "top" }}
                            />
                          </div>
                        )}

                        <div style={{ display: "flex", gap: "5px" }}>
                          <Button
                            icon="pi pi-info-circle"
                            onClick={() => {
                              setReservaEditando(item);
                              setDialogInformacoes(true);
                            }}
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Detalhes"
                            tooltipOptions={{ position: "top" }}
                          />
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Caixa?.editar
                              ) {
                                setReservaEditando(item);
                                setEditarCaixa(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Caixa?.editar
                              ) ||
                              item.status === "aberto" ||
                              item.status === "pendente"
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Editar"
                            tooltipOptions={{ position: "top" }}
                          />
                          <Button
                            icon="pi pi-print"
                            className="p-button-outlined p-button-sm"
                            onClick={() => handleImprimirRecibo(item)}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Caixa?.editar
                              ) ||
                              item.status === "aberto" ||
                              item.status === "pendente"
                            }
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Imprimir"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              /* VISUALIZAÇÃO EM GRADE (mantém igual) */
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {caixasFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginBottom: "12px",
                        }}
                      >
                        <div>
                          {item.status === "fechado" ? (
                            <span
                              style={{
                                backgroundColor: "#d4edda",
                                color: "#155724",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "0.85rem",
                                fontWeight: "600",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <i
                                className="pi pi-check"
                                style={{ fontSize: "0.7rem" }}
                              />
                              FECHADO
                            </span>
                          ) : (
                            <span
                              style={{
                                backgroundColor: "#fff3cd",
                                color: "#856404",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "0.85rem",
                                fontWeight: "600",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <i
                                className="pi pi-clock"
                                style={{ fontSize: "0.7rem" }}
                              />
                              ABERTO
                            </span>
                          )}
                        </div>

                        {(item.status === "aberto" ||
                          item.status === "pendente") && (
                          <div style={{ display: "flex", gap: "5px" }}>
                            <Button
                              icon="pi pi-check"
                              onClick={() => {
                                if (
                                  user.tipo === "administrator" ||
                                  user.modulos?.Caixa?.editar
                                ) {
                                  setPagamentoSelecionado(item);
                                  setShowFecharCaixa(true);
                                }
                              }}
                              disabled={
                                !(
                                  user.tipo === "administrator" ||
                                  user.modulos?.Caixa?.editar
                                )
                              }
                              className="p-button-success p-button-sm"
                              style={{
                                outline: "none",
                                boxShadow: "none",
                                width: "25px",
                                height: "25px",
                                borderColor: "#dee2e6",
                              }}
                              tooltip="Finalizar caixa"
                              tooltipOptions={{ position: "top" }}
                            />
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <FaUserCircle
                          style={{
                            fontSize: "2.5rem",
                            color: "#D65A55",
                            flexShrink: 0,
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.paciente_nome}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                              fontSize: "0.85rem",
                            }}
                          >
                            <i
                              className="pi pi-phone"
                              style={{ fontSize: "0.7rem" }}
                            />
                            <span>{item.paciente_telefone}</span>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            color: "#64748b",
                            fontSize: "0.85rem",
                          }}
                        >
                          <i
                            className="pi pi-tag"
                            style={{ fontSize: "0.7rem" }}
                          />
                          <span>{item.agendamento_id}</span>
                        </div>
                      </div>

                      {visualizacaoResumida && (
                        <>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "6px",
                              marginBottom: "5px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e8e8e8",
                                padding: "6px",
                                borderRadius: "6px",
                                flexDirection: "column",
                                gap: "5px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaCalendarAlt
                                  style={{
                                    color: "#2ecc71",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#2c3e50",
                                    fontWeight: "500",
                                  }}
                                >
                                  {formatarData(item.data_atendimento)}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaClock
                                  style={{
                                    color: "#f39c12",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#2c3e50",
                                    fontWeight: "500",
                                  }}
                                >
                                  {formatarHorario(item.horario)}
                                </span>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e8e8e8",
                                padding: "6px",
                                borderRadius: "6px",
                                flexDirection: "column",
                                gap: "5px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaBuilding
                                  style={{
                                    color: "#3498db",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#2c3e50",
                                    fontWeight: "500",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.empresa_nome}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaUserMd
                                  style={{
                                    color: "#9b59b6",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#2c3e50",
                                    fontWeight: "500",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.profissional_nome}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "6px",
                              marginBottom: "5px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e8e8e8",
                                padding: "6px",
                                borderRadius: "6px",
                                flexDirection: "column",
                                gap: "5px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaCalendarAlt
                                  style={{
                                    color: "#e74c3c",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#2c3e50",
                                    fontWeight: "500",
                                  }}
                                >
                                  {item.data_fechamento
                                    ? formatarData(item.data_fechamento)
                                    : formatarData(item.data_atualizacao)}
                                </span>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e8e8e8",
                                padding: "6px",
                                borderRadius: "6px",
                                flexDirection: "column",
                                gap: "5px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <FaCashRegister
                                  style={{
                                    color: "#e74c3c",
                                    fontSize: "0.75rem",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#2c3e50",
                                    fontWeight: "500",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  R$ {item.valor_total}
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: visualizacaoResumida
                            ? "1px solid #e8e8e8"
                            : "",
                        }}
                      >
                        <div style={{ display: "flex", gap: "5px" }}>
                          <Button
                            icon="pi pi-info-circle"
                            onClick={() => {
                              setReservaEditando(item);
                              setDialogInformacoes(true);
                            }}
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Detalhes"
                            tooltipOptions={{ position: "top" }}
                          />
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              if (
                                user.tipo === "administrator" ||
                                user.modulos?.Caixa?.editar
                              ) {
                                setReservaEditando(item);
                                setEditarCaixa(true);
                              }
                            }}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Caixa?.editar
                              ) ||
                              item.status === "aberto" ||
                              item.status === "pendente"
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Editar"
                            tooltipOptions={{ position: "top" }}
                          />
                          <Button
                            icon="pi pi-print"
                            className="p-button-outlined p-button-sm"
                            onClick={() => handleImprimirRecibo(item)}
                            disabled={
                              !(
                                user.tipo === "administrator" ||
                                user.modulos?.Caixa?.editar
                              ) ||
                              item.status === "aberto" ||
                              item.status === "pendente"
                            }
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Imprimir"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="8"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Caixa;